// Module Federation requires an async boundary at the entry point.
// All app initialization has been moved to bootstrap.tsx.
import("./bootstrap")

export {}
